import React from 'react';
import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0 },
};

const SectionHeader = ({ eyebrow, title, intro }) => (
  <motion.div
    className="section-heading"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
    variants={fadeUp}
    transition={{ duration: 0.55 }}
  >
    <p className="eyebrow">{eyebrow}</p>
    <h2>{title}</h2>
    <p>{intro}</p>
  </motion.div>
);

export default SectionHeader;
